import { ODataObject } from '../../interfaces/odata-model.interface';
import { assignModelOptions } from '../../utilities/assign-model-options';
import { ArrayModel, JsonArrayModel } from '../complex/array.model';
import { CompositeModel } from '../complex/composite.model';
import { EquipmentModel } from '../complex/equipment.model';
import {
    JsonMeasuringPointModel,
    MeasuringPointModel,
    ODataMeasuringPointOutModel,
} from '../low-level/measuring-point.model';

export class ConfirmationMeasuringPointsModel extends CompositeModel {
    public points: ArrayModel<MeasuringPointModel>;
    public constructor(equipments: EquipmentModel[]) {
        super('ConfirmationMeasuringPointsModel', {});
        const points: MeasuringPointModel[] = [];

        equipments.forEach((equipment) => {
            if (equipment.measuringPoint.value) {
                points.push(new MeasuringPointModel(equipment));
            }
        });

        this.points = <ArrayModel<MeasuringPointModel>>(
            this.set(new ArrayModel<MeasuringPointModel>('MeasPointSet', points))
        );
    }

    public getOutModel(): ODataConfirmationMeasuringPointsOutModel {
        return <ODataConfirmationMeasuringPointsOutModel>super.getOutModel();
    }
}

export class ConfirmationMeasuringPointsModelFromJson extends ConfirmationMeasuringPointsModel {
    public constructor(data: JsonConfirmationMeasuringPointsModel, equipments: EquipmentModel[]) {
        super(equipments);

        (<JsonMeasuringPointModel[]>data.points.value).forEach((jsonPoint) => {
            const point = this.points.value.find(
                (measuringPoint) => measuringPoint.measuringPointID.value === jsonPoint.measuringPointID.value,
            );

            if (!point) {
                throw new Error(`Could not find measuring point with ID ${jsonPoint.measuringPointID.value} in data`);
            }

            point.newValue.value = jsonPoint.newValue.value;
            point.isNotAvailable.model.value = <boolean>jsonPoint.isNotAvailable.model.value;
            point.newValue = assignModelOptions(
                point.newValue,
                {
                    ...point.newValue.options,
                    readonly: point.isNotAvailable.model.value,
                    required: !point.isNotAvailable.model.value,
                },
                point,
            );
        });
    }
}

export interface JsonConfirmationMeasuringPointsModel {
    points: JsonArrayModel;
}

export interface ODataConfirmationMeasuringPointsOutModel extends ODataObject {
    MeasPointSet: ODataMeasuringPointOutModel[];
}
